import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

export const QuoteExpired = {
  Content: lazy(
    () =>
      import(
        'components/abandoned-cart/components/QuoteExpired/QuoteExpiredContent'
      )
  ),
  Footer: lazy(
    () =>
      import(
        'components/abandoned-cart/components/QuoteExpired/QuoteExpiredFooter'
      )
  )
};

export default QuoteExpired;
